/* Insumos de Pestañas Chile, lote 3.
   Botón de favorito en la esquina superior derecha de la foto de cada ficha.

   Va por JS y no por Liquid a propósito: card-gallery.liquid es un archivo
   del tema base y tocarlo complica cualquier actualización de Horizon. El
   observer cubre las tarjetas que llegan después, tanto por "Mostrar más"
   como por el render de sección que dispara el filtro de colección.

   30-ago-2026, ARREGLO. Este bloque tenía su PROPIO almacén, un mapa bajo la
   llave "ipc:favoritos", mientras que el sistema real de favoritos vive en
   calibre.js y guarda un arreglo bajo "calibre:favoritos" con nombre, foto y
   precio para poder dibujar el panel sin pedirle nada a la red. O sea: el
   corazón guardaba en una llave que el panel nunca leía. Se marcaba, y el
   contador del encabezado y la lista seguían en cero para siempre.

   Ahora este archivo NO guarda nada. Solo inyecta el botón con los mismos
   atributos data-fav* que emite snippets/calibre-card.liquid, y deja que el
   escuchador delegado de calibre.js haga el trabajo: guardar, repintar los
   botones y repintar el panel. Un solo dueño del estado.

   Los datos del producto se sacan del DOM de la tarjeta porque acá no hay
   Liquid: la tarjeta ya trae el enlace, el título, la marca, el precio y la
   foto, que es exactamente lo que el panel necesita. */
(function () {
  var LLAVE = 'calibre:favoritos';
  var CORAZON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.2c-.42 0-.83-.15-1.15-.42C7.9 17.36 3.4 13.6 3.4 9.5A4.9 4.9 0 0 1 12 6.6' +
    'a4.9 4.9 0 0 1 8.6 2.9c0 4.1-4.5 7.86-7.45 10.28-.32.27-.73.42-1.15.42Z"/></svg>';

  /* Solo para pintar el estado inicial del botón recién inyectado. Escribir
     es tarea de calibre.js. */
  function guardados() {
    try {
      var d = JSON.parse(window.localStorage.getItem(LLAVE) || '[]');
      var ids = {};
      for (var i = 0; i < d.length; i++) {
        var x = d[i];
        ids[typeof x === 'string' ? x : x.id] = 1;
      }
      return ids;
    } catch (e) {
      return {};
    }
  }

  /* La llave vieja nunca alimentó nada. Se limpia una vez para no dejar
     estado fantasma en el navegador de quien probó la tienda antes. */
  try {
    window.localStorage.removeItem('ipc:favoritos');
  } catch (e) {}

  function texto(raiz, selector) {
    var n = raiz.querySelector(selector);
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function idDe(galeria) {
    var id = galeria.getAttribute('data-product-id');
    if (id) return id;
    var ficha = galeria.closest ? galeria.closest('product-card') : null;
    return ficha ? ficha.getAttribute('data-product-id') : '';
  }

  function poner(raiz) {
    var galerias = (raiz || document).querySelectorAll('.card-gallery');
    var ids = guardados();

    for (var i = 0; i < galerias.length; i++) {
      var g = galerias[i];
      if (g.querySelector(':scope > .cal-fav')) continue;

      /* Solo en tarjetas de listado. La galería de la página de producto es
         otra cosa y ahí el corazón estorba. */
      var ficha = g.closest ? g.closest('product-card') : null;
      if (!ficha) continue;

      var id = idDe(g);
      if (!id) continue;

      var enlace = ficha.querySelector('a[href*="/products/"]');
      var foto = ficha.querySelector('img');

      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'cal-fav';

      /* Los mismos nombres que usa snippets/calibre-card.liquid, para que el
         escuchador de calibre.js los reconozca sin cambios. */
      boton.setAttribute('data-fav', id);
      boton.setAttribute('data-fav-url', enlace ? enlace.getAttribute('href') : '');
      boton.setAttribute('data-fav-titulo', texto(ficha, '.product-title, [class*="title"]'));
      boton.setAttribute('data-fav-marca', texto(ficha, '[class*="vendor"]'));
      boton.setAttribute('data-fav-precio', texto(ficha, 'product-price, .price'));
      boton.setAttribute('data-fav-foto', foto ? foto.currentSrc || foto.src || '' : '');

      boton.setAttribute('aria-pressed', ids[id] ? 'true' : 'false');
      boton.setAttribute('aria-label', ids[id] ? 'Quitar de favoritos' : 'Guardar en favoritos');
      boton.innerHTML = CORAZON;

      g.appendChild(boton);
    }
  }

  /* El latido al marcar. Va aparte y sin preventDefault para no robarle el
     evento al escuchador de calibre.js, que es quien guarda. */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('.cal-fav') : null;
    if (!b) return;
    b.classList.add('is-marcando');
    setTimeout(function () {
      b.classList.remove('is-marcando');
    }, 340);
  });

  function arrancar() {
    poner(document);

    var observador = new MutationObserver(function (mutaciones) {
      var hayNuevas = false;
      for (var i = 0; i < mutaciones.length; i++) {
        if (mutaciones[i].addedNodes && mutaciones[i].addedNodes.length) {
          hayNuevas = true;
          break;
        }
      }
      if (hayNuevas) poner(document);
    });

    observador.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/* Insumos de Pestañas Chile, aviso de reposición.

   El enlace "Avísame cuando llegue" llevaba a /pages/reposicion, una página de
   texto: el visitante leía y se iba, y la tienda no se quedaba con ningún
   dato. Ahora abre una ventana y captura el correo.

   Va contra el formulario de contacto de Shopify, que es un POST plano a
   /contact sin token, así que se puede armar desde JS. La alternativa era
   declararlo en Liquid, pero eso obligaba a tocar la sección de cabecera o la
   del pie, que son archivos grandes con otro trabajo encima.

   El aviso llega al correo de contacto de la tienda con el nombre y la
   dirección del producto. NO dispara ningún envío automático hacia el
   visitante: en este proyecto eso no se activa sin visto bueno. */
(function () {
  var LLAVE = 'ipc:aviso-pedido';
  var modal = null;
  var focoPrevio = null;

  function construir() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'cal-aviso';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="cal-aviso__fondo" data-cerrar></div>' +
      '<div class="cal-aviso__caja" role="dialog" aria-modal="true" aria-labelledby="cal-aviso-t">' +
        '<button type="button" class="cal-aviso__cerrar" data-cerrar aria-label="Cerrar">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
          'stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<p class="cal-aviso__titulo" id="cal-aviso-t">Avísame cuando llegue</p>' +
        '<p class="cal-aviso__producto" data-producto></p>' +
        '<form class="cal-aviso__form" method="post" action="/contact#cal-aviso" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="contact">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[body]" data-cuerpo value="">' +
          '<label class="visually-hidden" for="cal-aviso-email">Tu correo</label>' +
          '<input class="cal-aviso__email" id="cal-aviso-email" type="email" name="contact[email]" ' +
            'required autocomplete="email" placeholder="tucorreo@ejemplo.cl">' +
          '<button class="cal-aviso__enviar" type="submit">Avisarme</button>' +
        '</form>' +
        '<p class="cal-aviso__nota">Te escribimos apenas vuelva a haber stock. El correo no se usa para nada más.</p>' +
      '</div>';

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-cerrar]')) cerrar();
    });

    modal.querySelector('form').addEventListener('submit', function () {
      /* El nombre se guarda antes de enviar porque el formulario recarga la
         página y después ya no hay forma de saber cuál era. */
      try {
        window.sessionStorage.setItem(LLAVE, modal.querySelector('[data-producto]').textContent || '');
      } catch (err) {
        /* modo privado: se pierde el nombre, el aviso genérico igual sale */
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function abrir(boton) {
    var m = construir();
    var nombre = boton.getAttribute('data-producto') || '';
    var ruta = boton.getAttribute('data-url') || '';

    m.querySelector('[data-producto]').textContent = nombre;
    m.querySelector('[data-cuerpo]').value =
      'Aviso de reposición solicitado desde la tienda.\n' +
      'Producto: ' + nombre + '\n' +
      'Ficha: ' + window.location.origin + ruta;

    focoPrevio = document.activeElement;
    m.removeAttribute('hidden');
    document.documentElement.classList.add('cal-aviso-abierto');
    var campo = m.querySelector('.cal-aviso__email');
    if (campo) campo.focus();
  }

  function cerrar() {
    if (!modal || modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('cal-aviso-abierto');
    if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
    focoPrevio = null;
  }

  function confirmar() {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;

    /* El boletín del pie postea al MISMO /contact que esta ventana. Si Shopify
       devuelve contact_posted=true también para ese envío, sin esta guarda
       cualquiera que se suscriba vería "te avisamos apenas vuelva a haber
       stock" por un producto que nunca pidió. Solo esta ventana escribe la
       llave, así que si no está, el envío no fue de acá y no se pinta nada.
       El precio es perder el globo en modo privado, mucho menos malo que dar
       un aviso falso. */
    var nombre = null;
    try {
      nombre = window.sessionStorage.getItem(LLAVE);
      window.sessionStorage.removeItem(LLAVE);
    } catch (err) {
      nombre = null;
    }
    if (nombre === null) return;

    var aviso = document.createElement('div');
    aviso.className = 'cal-aviso-ok';
    aviso.setAttribute('role', 'status');
    var txt = document.createElement('p');
    txt.textContent = nombre
      ? 'Listo. Te avisamos apenas llegue ' + nombre + '.'
      : 'Listo. Te avisamos apenas vuelva a haber stock.';
    aviso.appendChild(txt);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'cal-aviso-ok__cerrar';
    x.setAttribute('aria-label', 'Cerrar');
    x.textContent = '×';
    x.addEventListener('click', function () { aviso.remove(); });
    aviso.appendChild(x);

    document.body.appendChild(aviso);
    setTimeout(function () { if (aviso.parentNode) aviso.remove(); }, 9000);
  }

  function arrancar() {
    /* Delegado en el documento: las tarjetas llegan también por "Mostrar más"
       y por el render de sección del filtro, así que enganchar botón por
       botón dejaría fuera a las que aparecen después. */
    document.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-cal-aviso]');
      if (!boton) return;
      /* La tarjeta entera es un enlace: sin esto el clic navega al producto. */
      e.preventDefault();
      e.stopPropagation();
      abrir(boton);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrar();
    });

    confirmar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();


/* Insumos de Pestañas Chile, lote 3.
   Mega menú de categorías de tres niveles en la barra .cal-catnav.

   Patrón elegido: Disclosure Navigation. Cada categoría con hijos tiene un
   ancla que navega a la colección y, al lado, un botón con aria-expanded que
   abre el panel. NO se usa role="menubar" ni menuitem: esto son enlaces de
   navegación de un sitio, no comandos de aplicación, y el patrón menubar
   obligaría a secuestrar las flechas del teclado, que en modo lectura de
   lector de pantalla sorprende y en el navegador rompe el desplazamiento.
   Si alguien audita esperando menubar, la decisión está tomada a conciencia.

   ACOPLAMIENTO, no borrar: assets/calibre-extra.js arma las fichas del cajón
   móvil con querySelectorAll('.cal-catnav__link'), toma las 10 primeras y
   empareja href con textContent por índice. Por eso los enlaces internos del
   panel usan .cal-mega__enlace y .cal-mega__grupotit, nunca .cal-catnav__link.

   Modo degradado aceptado: si este archivo no carga, el panel nunca se abre y
   la barra sigue funcionando como antes, con sus enlaces de categoría intactos. */
(function () {
  var nav = document.querySelector('[data-cal-mega-nav]');
  if (!nav) return;

  var mqEscritorio = window.matchMedia('(min-width: 990px)');
  /* Entre 990 y 1024px hay portátiles y tablets táctiles. Sin esta guarda el
     primer toque abriría el panel y se comería el toque destinado al enlace de
     la categoría. Con ella, en táctil solo abre el chevron, que es un objetivo
     explícito. */
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqQuieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ABRIR_FRIO = 120;       // el puntero que cruza una pastilla camino al buscador pasa entre 40 y 90 ms
  var RELEVO_CALIENTE = 90;   // con un panel ya abierto, el viaje en diagonal hacia la gráfica roza las pastillas vecinas: sin esta espera el panel se cambia solo en el camino
  var CERRAR = 220;           // el viaje en diagonal hasta el extremo opuesto del panel toma de 150 a 300 ms, y también cubre los 11px de padding de la fila
  var OCULTAR = 140;          // 120 de la transición de salida más 20 de margen
  var TOLERANCIA = 24;        // temblor de trackpad que no cuenta como scroll
  var PEGADO = 24;            // si a la pastilla le quedan menos de 24px hasta el borde de la banda, el panel se pega abajo del todo

  /* La página no siempre se desplaza en window: Horizon usa .page-wrapper. Se
     guarda una sola vez, igual que calibre.js en la línea 876: consultarlo en
     cada evento de scroll fuerza un reflujo decenas de veces por segundo justo
     mientras hay un panel de ancho completo pintado. */
  var envoltorio = document.querySelector('.page-wrapper');

  var abierto = null;         // el .cal-catnav__item que tiene el panel abierto
  var tAbrir = null;
  var tCerrar = null;
  var cerrandoItem = null;    // de quién es el cierre pendiente, ver focusin
  var yAlAbrir = 0;

  function quieto() {
    return mqQuieto.matches;
  }

  function panelDe(item) {
    return item.querySelector('[data-cal-mega-panel]');
  }

  function botonDe(item) {
    return item.querySelector('[data-cal-mega-toggle]');
  }

  function posScroll() {
    if (envoltorio && envoltorio.scrollHeight > envoltorio.clientHeight + 4) return envoltorio.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function limpiarCierre() {
    if (tCerrar) clearTimeout(tCerrar);
    tCerrar = null;
    cerrandoItem = null;
  }

  /* El panel cuelga de .cal-catnav y no del ítem, así que su sitio lo escribe
     el JS. Se recalcula en CADA apertura: la fila usa flex-wrap y se parte en
     dos líneas según el ancho de la ventana.

     La y es el borde inferior de la FILA de la pastilla. Con la barra en una
     sola fila coincide con el 100% de siempre; con la barra partida, el panel
     baja pegado a su propia fila y tapa la de abajo. Si colgara del final de la
     barra, para llegar al panel desde una pastilla de la primera fila habría
     que cruzar la segunda, y cada pastilla cruzada cambiaría el panel. */
  function ubicar(item, panel) {
    var alto = nav.clientHeight;
    var y = item.offsetTop + item.offsetHeight;
    if (alto - y < PEGADO) y = alto;
    panel.style.setProperty('--cal-mega-y', y + 'px');

    if (panel.className.indexOf('cal-mega--corto') === -1) return;
    var ancho = panel.offsetWidth;
    var tope = nav.clientWidth - ancho - 16;
    var x = item.offsetLeft;
    if (x > tope) x = tope;
    if (x < 16) x = 16;
    panel.style.setProperty('--cal-mega-x', x + 'px');
  }

  function abrir(item) {
    if (!mqEscritorio.matches) return;
    if (abierto === item) return;
    if (abierto) ocultarYa(abierto);

    var panel = panelDe(item);
    var boton = botonDe(item);
    if (!panel || !boton) return;

    if (panel.ocultarTimer) {
      clearTimeout(panel.ocultarTimer);
      panel.ocultarTimer = null;
    }

    panel.removeAttribute('hidden');
    ubicar(item, panel);

    /* Reflujo forzado y sincrónico, no requestAnimationFrame: rAF se congela
       en pestañas en segundo plano y el panel se quedaría en opacity 0 con la
       clase sin aplicar. calibre.js:903 ya había descartado rAF por lo mismo,
       y en el editor de temas la vista previa vive en un iframe que puede
       quedar oculto justo mientras la clienta configura la gráfica. */
    void panel.offsetWidth;
    panel.classList.add('is-abierto');

    boton.setAttribute('aria-expanded', 'true');
    abierto = item;
    yAlAbrir = posScroll();
  }

  /* Cierre con transición: se saca la clase y el atributo hidden entra después,
     porque hidden es lo que deja los paneles cerrados fuera del orden de
     tabulación. Sin él habría que atravesar unos 70 enlaces invisibles. */
  function cerrar(item) {
    if (!item) return;
    var panel = panelDe(item);
    var boton = botonDe(item);
    if (!panel || !boton) return;

    panel.classList.remove('is-abierto');
    boton.setAttribute('aria-expanded', 'false');
    if (abierto === item) abierto = null;

    if (panel.ocultarTimer) clearTimeout(panel.ocultarTimer);
    if (quieto()) {
      panel.setAttribute('hidden', '');
      panel.ocultarTimer = null;
    } else {
      panel.ocultarTimer = setTimeout(function () {
        panel.setAttribute('hidden', '');
        panel.ocultarTimer = null;
      }, OCULTAR);
    }
  }

  /* Cierre sin transición, para Escape, para el scroll y para el relevo entre
     dos paneles: ahí cualquier desvanecido se lee como pegajosidad. */
  function ocultarYa(item) {
    if (!item) return;
    var panel = panelDe(item);
    var boton = botonDe(item);
    if (!panel || !boton) return;

    if (panel.ocultarTimer) {
      clearTimeout(panel.ocultarTimer);
      panel.ocultarTimer = null;
    }
    panel.classList.remove('is-abierto');
    panel.setAttribute('hidden', '');
    boton.setAttribute('aria-expanded', 'false');
    if (abierto === item) abierto = null;
  }

  function cerrarTodo() {
    if (abierto) ocultarYa(abierto);
    if (tAbrir) { clearTimeout(tAbrir); tAbrir = null; }
    limpiarCierre();
  }

  function montar(item) {
    if (item.getAttribute('data-cal-montado') === '1') return;
    var boton = botonDe(item);
    if (!boton) return;
    item.setAttribute('data-cal-montado', '1');

    /* El clic del chevron funciona con cualquier puntero: es la única vía de
       abrir en táctil y la que usa el teclado con Enter o Espacio. */
    boton.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (!mqEscritorio.matches) return;
      if (abierto === item) cerrar(item);
      else abrir(item);
    });

    if (mqHover.matches) {
      item.addEventListener('mouseenter', function () {
        if (!mqEscritorio.matches) return;
        limpiarCierre();
        if (tAbrir) { clearTimeout(tAbrir); tAbrir = null; }
        /* Volver a entrar al ítem que ya está abierto, por ejemplo al bajar
           de la pastilla al panel, solo cancela lo pendiente. */
        if (abierto === item) return;
        /* En frío se espera más; en caliente igual se espera, porque el panel
           es una banda de ancho completo y el recorrido en diagonal hacia la
           gráfica pasa por encima de las pastillas vecinas. */
        var espera = abierto ? RELEVO_CALIENTE : ABRIR_FRIO;
        tAbrir = setTimeout(function () {
          tAbrir = null;
          abrir(item);
        }, espera);
      });

      /* El cierre apunta al panel ABIERTO, no a este ítem. Secuencia real: A
         está abierto, el puntero pasa por encima de B camino a la salida y se
         va antes de los 90ms del relevo. Si el temporizador cerrara "item",
         cerraría a B, que no tiene nada abierto, y A se quedaría colgado
         encima de la página para siempre. */
      item.addEventListener('mouseleave', function () {
        if (tAbrir) { clearTimeout(tAbrir); tAbrir = null; }
        if (!abierto) return;
        var objetivo = abierto;
        if (tCerrar) clearTimeout(tCerrar);
        cerrandoItem = objetivo;
        tCerrar = setTimeout(function () {
          tCerrar = null;
          cerrandoItem = null;
          cerrar(objetivo);
        }, CERRAR);
      });
    }

    /* El foco sobre el ENLACE de categoría no abre nada: si cada Tab por la
       barra hiciera estallar una banda de ancho completo, navegar con teclado
       sería insoportable. Pero el foco dentro del ítem sí cancela SU cierre
       pendiente. Se comprueba de quién es el cierre: si está armado el de A y
       el foco entra en B, limpiarlo dejaría a A abierto para siempre. */
    item.addEventListener('focusin', function () {
      if (cerrandoItem === item) limpiarCierre();
    });

    item.addEventListener('focusout', function (ev) {
      var destino = ev.relatedTarget;
      /* Sin destino el foco no se fue a ninguna parte: un clic en el aire
         entre dos columnas, o un cambio de ventana. El puntero sigue dentro
         del panel y cerrarlo ahí no tiene explicación visible. El cierre por
         clic fuera cubre el descarte de verdad. */
      if (!destino) return;
      if (item.contains(destino)) return;
      if (abierto === item) cerrar(item);
    });
  }

  function montarTodos() {
    var items = nav.querySelectorAll('[data-cal-mega-item]');
    for (var i = 0; i < items.length; i++) montar(items[i]);
  }
  montarTodos();

  /* Escape va delegado en el documento y no en la barra: el editor de temas
     reemplaza el nodo de la sección entera al recargarla y un oyente pegado a
     la barra vieja se quedaría sin efecto. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
    if (!abierto) return;
    var item = abierto;
    var boton = botonDe(item);
    /* El foco solo se mueve si venía de adentro. El panel se abre por hover,
       así que lo normal es tenerlo abierto con el foco en el buscador, que
       tiene su propio Escape en calibre.js:749: sin esta guarda, cerrar las
       sugerencias le arrancaba el foco del campo al chevron. */
    var dentro = item.contains(document.activeElement);
    ocultarYa(item);
    if (dentro && boton) boton.focus();
  });

  /* Cierre por clic o toque fuera. En un táctil de 990px o más, un iPad en
     horizontal por ejemplo, mqHover es falso y no hay mouseleave: sin esto el
     panel se queda abierto tapando la página hasta acertarle otra vez al
     chevron de 18px. Es además lo que pide el criterio 1.4.13 de WCAG 2.1,
     que el contenido que aparece al apuntar se pueda descartar. Va en
     pointerdown y no en click para no comerse la navegación de los enlaces
     del propio panel. */
  document.addEventListener('pointerdown', function (ev) {
    if (!abierto) return;
    var t = ev.target;
    if (t && t.closest && t.closest('[data-cal-mega-item]') === abierto) return;
    ocultarYa(abierto);
  });

  /* calibre.js (línea 893) le pone cal-sticky--fuera a la sección al bajar, y
     en escritorio esa traslación no está anulada: con el panel abierto se iría
     con la cabecera y quedaría medio menú colgando del borde superior. */
  function alScroll() {
    if (!abierto) return;
    if (Math.abs(posScroll() - yAlAbrir) > TOLERANCIA) cerrarTodo();
  }
  window.addEventListener('scroll', alScroll, { passive: true });
  if (envoltorio) envoltorio.addEventListener('scroll', alScroll, { passive: true });

  /* Al cambiar de tamaño la fila se reacomoda y la pastilla puede saltar de
     línea, así que el sitio guardado del panel deja de valer. Se cierra en vez
     de recolocar: es más barato y menos raro que ver el panel saltando
     mientras se arrastra el borde de la ventana. */
  window.addEventListener('resize', cerrarTodo, { passive: true });

  /* El panel de favoritos se monta encima: conviene sacar el mega antes. */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-favpanel-abrir]')) cerrarTodo();
  });

  /* Si se cruza el corte de 990px con un panel abierto, queda colgado. */
  if (mqEscritorio.addEventListener) {
    mqEscritorio.addEventListener('change', cerrarTodo);
  } else if (mqEscritorio.addListener) {
    mqEscritorio.addListener(cerrarTodo);
  }

  /* Editor de temas. Sin esto la clienta no puede ver la gráfica mientras la
     configura, porque el panel está oculto por defecto, y la parte
     configurable del encargo le queda inservible. Ojo: si el bloque no engancha
     con ninguna categoría no existe elemento y este atajo no la puede rescatar,
     por eso el Liquid pinta además el aviso de bloques huérfanos. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var item = t.closest('[data-cal-mega-item]');
      if (item) abrir(item);
    });

    document.addEventListener('shopify:block:deselect', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var item = t.closest('[data-cal-mega-item]');
      if (item) cerrar(item);
    });

    document.addEventListener('shopify:section:load', function () {
      cerrarTodo();
      var nuevo = document.querySelector('[data-cal-mega-nav]');
      if (!nuevo || nuevo === nav) return;
      nav = nuevo;
      montarTodos();
    });
  }
})();

/* Insumos de Pestañas Chile: botón de volver arriba.

   La competencia lo tiene y aquí hace falta de verdad. La colección Lifting
   trae 106 productos que entran de a 24 con "Mostrar más", así que el
   documento pasa de los 14.000 px y el regreso al principio son quince
   deslizamientos o más.

   Cuelga del <body> y no de una sección porque tiene que existir en colección,
   en buscador, en ficha y en artículo, y esas plantillas no comparten ninguna
   sección.

   La función de arranque se llama arrancarVolver y no arrancar como las dos
   de más arriba. Cada IIFE tiene su propio ámbito, así que no había choque,
   pero los tres cierres eran texto idéntico y cualquier inserción por ancla
   en este archivo caía en el sitio equivocado. */
(function () {
  /* Aparece a los 800 px: en teléfono eso es algo más de una pantalla completa
     de contenido, porque el alto útil anda entre 640 y 750 px. Es el punto en
     que el principio del documento ya NO se alcanza con un solo deslizamiento
     y el atajo empieza a pagar su lugar en pantalla. Con 300 px estaría puesto
     casi siempre, tapando producto sin necesidad, porque a esa altura todavía
     se vuelve arriba de un tirón. Con 2.000 px el usuario ya va en la fila
     ocho de doce de la primera tanda antes de recibir ayuda.

     Se va a los 560 px y no a los mismos 800: el rebote elástico de iOS y la
     inercia hacen que la posición oscile alrededor del umbral, y con un solo
     número el botón parpadea. La banda muerta de 240 px lo estabiliza. */
  var UMBRAL_ENTRA = 800;
  var UMBRAL_SALE = 560;

  var FLECHA =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M12 19.5V5"/><path d="m5 11.5 7-6.5 7 6.5"/></svg>';

  var boton = null;
  var visible = false;
  var pendiente = false;

  /* La preferencia se consulta en cada pulsación y no una vez al cargar: el
     sistema operativo la puede cambiar con la pestaña ya abierta. */
  function prefiereQuieto() {
    return !!(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function evaluar() {
    pendiente = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    /* Solo se cambia una CLASE, nunca se inserta ni se quita el botón del DOM.
       Es deliberado: el MutationObserver de favoritos que vive más arriba en
       este mismo archivo escucha childList sobre todo el body, así que cada
       inserción dispararía un recorrido completo de .card-gallery en la
       página. Un cambio de clase es una mutación de atributo y no lo despierta. */
    if (!visible && y > UMBRAL_ENTRA) {
      visible = true;
      boton.classList.add('cal-volver--visible');
    } else if (visible && y < UMBRAL_SALE) {
      visible = false;
      boton.classList.remove('cal-volver--visible');
    }
  }

  /* Estrangulado con requestAnimationFrame y una bandera: el navegador dispara
     scroll decenas de veces por segundo y aquí se trabaja como máximo una vez
     por cuadro, justo antes de pintar. El listener va passive para no bloquear
     el desplazamiento mientras se decide.

     No se usa debounce con setTimeout porque llega tarde por definición: el
     botón aparecería recién cuando el dedo se detiene, o sea después del
     momento en que se necesita, y entraría de golpe sobre una pantalla quieta.

     No se usa IntersectionObserver con un centinela, que en teoría es más
     barato todavía, porque el centinela hay que fijarlo a 800 px del inicio
     del documento y eso obliga a poner position:relative en el <body>, que en
     esta tienda ya carga el relleno inferior de la barra de pestañas y convive
     con la cabecera fija. Mover ese contexto de posicionamiento no compensa
     ahorrar una lectura de pageYOffset por cuadro, que además no fuerza
     recálculo de estilo. */
  function alRodar() {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(evaluar);
  }

  function alPulsar() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefiereQuieto() ? 'auto' : 'smooth'
    });

    /* El botón desaparece al llegar arriba, así que el foco del teclado se
       quedaría colgando al final del documento. Se devuelve al principio del
       contenido, con preventScroll para no pelear con el desplazamiento suave
       recién iniciado, y el tabindex prestado se retira al salir para no
       ensuciar el orden de tabulación. */
    var destino = document.querySelector('main') || document.body;
    destino.setAttribute('tabindex', '-1');
    try {
      destino.focus({ preventScroll: true });
    } catch (e) {
      destino.focus();
    }
    destino.addEventListener('blur', function limpiar() {
      destino.removeAttribute('tabindex');
      destino.removeEventListener('blur', limpiar);
    });
  }

  function arrancarVolver() {
    /* En el editor de temas la página se vuelve a montar varias veces. Mismo
       resguardo que usa la barra inferior en calibre-extra.js. */
    if (document.querySelector('.cal-volver')) return;

    boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'cal-volver';
    boton.setAttribute('aria-label', 'Volver arriba');
    boton.innerHTML = FLECHA;
    boton.addEventListener('click', alPulsar);
    document.body.appendChild(boton);

    /* Una recarga a media página, o una vuelta atrás del navegador, llegan con
       el scroll puesto y sin que se dispare ningún evento. */
    evaluar();

    window.addEventListener('scroll', alRodar, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancarVolver);
  } else {
    arrancarVolver();
  }
})();

/* ==========================================================================
   AGREGAR AL CARRITO: QUE SE VEA LA ESPERA Y QUÉ PRODUCTO ENTRÓ
   30-ago-2026.

   Medido en vivo antes de escribir esto, apretando "Agregar" en una tarjeta
   de colección:

       clic ...............................     0 ms
       /cart/add.js responde ..............  1.399 ms
       el cajón del carrito recién abre ...  1.591 ms

   Durante esos 1,6 segundos el botón no cambiaba de clase, de texto ni de
   color: quien compra cree que no registró y aprieta de nuevo. Horizon sí
   trae un visto animado, pero lo enciende cuando la respuesta ya volvió, o
   sea justo cuando la duda ya se resolvió sola. Falta la otra mitad, la
   espera, y eso es lo que agrega este bloque.

   Además, que el cajón se abra no dice CUÁL producto entró: con nueve
   líneas adentro, la recién sumada no se distingue. Se resalta la fila y se
   le cuelga un sello por 2,6 s.

   No se toca el componente de Horizon: se escucha en fase de captura, que
   corre antes que su manejador, y se limpia con sus propios eventos.
   ========================================================================== */
(function () {
  'use strict';

  var BOTONES = '.add-to-cart-button, .cal-mini__cta';
  var TOPE_ESPERA = 9000; /* red de seguridad si la respuesta nunca llega */
  var SELLO_MS = 2600;
  var VISTO =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20 6.9 9.5 17.4 4 11.9"/></svg>';

  /* Sólo puede haber una espera viva: si se aprieta un segundo botón, la
     primera se da por terminada en vez de quedar girando para siempre. */
  var espera = null;

  function limpiarEspera() {
    if (!espera) return null;
    clearTimeout(espera.reloj);
    if (espera.boton) delete espera.boton.dataset.calEspera;
    var variante = espera.variante;
    espera = null;
    return variante;
  }

  /* El id de variante sale del propio formulario. Se filtra a dígitos porque
     después se mete en un selector: nunca se concatena texto sin limpiar. */
  function varianteDe(boton) {
    var form = boton.closest('form');
    var campo = form && form.querySelector('[name="id"]');
    var crudo = campo && campo.value ? String(campo.value) : '';
    var limpio = crudo.replace(/[^0-9]/g, '');
    return limpio || null;
  }

  function alPulsar(evento) {
    var boton = evento.target.closest ? evento.target.closest(BOTONES) : null;
    if (!boton || boton.disabled || boton.dataset.calEspera === '1') return;

    /* Mismo portero que usa Horizon: si el formulario no valida, no sale
       ninguna petición y el aro se quedaría girando sin motivo. */
    var form = boton.closest('form');
    if (form && form.checkValidity && !form.checkValidity()) return;

    limpiarEspera();
    boton.dataset.calEspera = '1';
    espera = {
      boton: boton,
      variante: varianteDe(boton),
      reloj: setTimeout(limpiarEspera, TOPE_ESPERA)
    };
  }

  function resaltar(fila) {
    var cajon = document.getElementById('cart-drawer');
    if (cajon) {
      Array.prototype.forEach.call(cajon.querySelectorAll('.cal-recien'), function (n) {
        n.classList.remove('cal-recien');
      });
      Array.prototype.forEach.call(cajon.querySelectorAll('.cal-recien__sello'), function (n) {
        n.parentNode.removeChild(n);
      });
    }

    fila.classList.add('cal-recien');

    var caja =
      fila.querySelector('.cart-items__product-info') ||
      fila.querySelector('.cart-items__details');

    if (caja && !caja.querySelector('.cal-recien__sello')) {
      var sello = document.createElement('span');
      sello.className = 'cal-recien__sello';
      sello.innerHTML = VISTO + 'Agregado';
      caja.appendChild(sello);
    }

    setTimeout(function () {
      fila.classList.remove('cal-recien');
      var s = fila.querySelector('.cal-recien__sello');
      if (s && s.parentNode) s.parentNode.removeChild(s);
    }, SELLO_MS);
  }

  /* El cajón se repinta por su cuenta y la fila puede aparecer un instante
     después del evento. Se reintenta un segundo y se abandona en silencio:
     no encontrarla no rompe nada, sólo no hay resalte. */
  function buscarFila(variante, quedan) {
    if (!variante) return;
    var cajon = document.getElementById('cart-drawer');
    var fila = cajon && cajon.querySelector('tr[data-key^="' + variante + ':"]');
    if (fila) {
      resaltar(fila);
      return;
    }
    if (quedan > 0) {
      setTimeout(function () {
        buscarFila(variante, quedan - 1);
      }, 140);
    }
  }

  function alTerminar() {
    var variante = limpiarEspera();
    if (variante) buscarFila(variante, 7);
  }

  /* Captura, no burbujeo: estos eventos se disparan sobre nodos internos y
     algunos no burbujean, pero la fase de captura pasa igual por document.
     Comprobado en vivo antes de confiar en ello. */
  document.addEventListener('click', alPulsar, true);
  document.addEventListener('theme-drawer:open', alTerminar, true);
  document.addEventListener('shopify:cart:view', alTerminar, true);
})();

/* ==========================================================================
   PREGUNTAS FRECUENTES: BUSCADOR Y ENLACE PROFUNDO
   30-ago-2026.

   El plegado NO se maneja acá: lo hace <details> por su cuenta, así que la
   página funciona entera sin JavaScript. Esto solo agrega dos comodidades.

   1. Filtrar. Con 22 preguntas, leerlas todas es el trabajo que la clienta no
      quiere hacer. Busca en la pregunta Y en la respuesta, así "factura"
      encuentra la pregunta aunque la palabra viva en el cuerpo. Se ignoran
      las tildes, porque nadie las escribe en un buscador.

   2. Abrir la pregunta a la que apunta el enlace. Cada una tiene su id, así
      soporte puede mandar el enlace exacto por WhatsApp en vez de "está en
      la FAQ". Sin esto llegaría cerrada y habría que buscarla igual.

   Los temas se ocultan cuando ninguna de sus preguntas sobrevive al filtro:
   un título de tema sin nada debajo se lee como que la sección está rota.
   ========================================================================== */
(function () {
  'use strict';

  function normalizar(t) {
    return (t || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function arrancar(raiz) {
    var campo = raiz.querySelector('[data-faq-buscar]');
    var limpiar = raiz.querySelector('[data-faq-limpiar]');
    var cuenta = raiz.querySelector('[data-faq-cuenta]');
    var vacio = raiz.querySelector('[data-faq-vacio]');
    var items = [].slice.call(raiz.querySelectorAll('[data-faq-item]'));
    var cats = [].slice.call(raiz.querySelectorAll('[data-faq-cat]'));

    /* El texto se indexa una sola vez: filtrar en cada tecla sobre el DOM
       vivo obligaría a leer el layout 22 veces por pulsación. */
    items.forEach(function (it) {
      it.__txt = normalizar(it.textContent);
    });

    function filtrar(q) {
      var t = normalizar(q);
      var vistos = 0;

      items.forEach(function (it) {
        var calza = !t || it.__txt.indexOf(t) !== -1;
        it.hidden = !calza;
        if (calza) vistos++;
        /* Buscando conviene ver la respuesta sin un clic más; al limpiar se
           vuelven a cerrar para no dejar la página desplegada entera. */
        if (t && calza) it.open = true;
        if (!t) it.open = false;
      });

      /* Un tema se muestra solo si tiene alguna pregunta viva por debajo,
         hasta el próximo tema. */
      cats.forEach(function (cat) {
        var vivo = false;
        var n = cat.nextElementSibling;
        while (n && !n.hasAttribute('data-faq-cat')) {
          if (n.hasAttribute('data-faq-item') && !n.hidden) { vivo = true; break; }
          n = n.nextElementSibling;
        }
        cat.hidden = !vivo;
      });

      if (limpiar) limpiar.hidden = !t;
      if (vacio) vacio.hidden = vistos !== 0;
      if (cuenta) {
        cuenta.hidden = !t;
        cuenta.textContent = vistos === 1 ? '1 pregunta' : vistos + ' preguntas';
      }
    }

    if (campo) {
      campo.addEventListener('input', function () { filtrar(campo.value); });
      /* Escape limpia sin sacar el foco, que es lo que espera quien escribe. */
      campo.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && campo.value) {
          e.preventDefault();
          campo.value = '';
          filtrar('');
        }
      });
    }

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        campo.value = '';
        filtrar('');
        campo.focus();
      });
    }

    function abrirDelEnlace() {
      var h = window.location.hash;
      if (!h || h.length < 2) return;
      var destino;
      try { destino = raiz.querySelector(h); } catch (e) { return; }
      if (!destino || !destino.hasAttribute('data-faq-item')) return;
      destino.open = true;
      destino.scrollIntoView({ block: 'center' });
    }

    abrirDelEnlace();
    window.addEventListener('hashchange', abrirDelEnlace);
  }

  function iniciar() {
    var raices = document.querySelectorAll('[data-faq]');
    for (var i = 0; i < raices.length; i++) arrancar(raices[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
